import React, { useEffect, useState } from 'react';
import { useWizard } from '../../wizard';
import { StepContainer, RadioGroup, NavigationButtons, InfoBox } from '../index';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const AskHasOldPassportStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [title, setTitle] = useState('Har du et gyldigt dansk pas i forvejen?');
  const [body, setBody] = useState<string[]>([]);

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.ask_has_old_passport).then(c => {
      if (c?.title) {setTitle(c.title);}
      if (c?.body) {setBody(c.body || []);}
    });
  }, []);

  const handleChange = (value: string) => {
    updateSelfServiceData('hasOldPassport', value === 'true');
  };

  const handleNext = () => {
    if (selfServiceData.hasOldPassport !== undefined) {
      goNext();
    }
  };

  const options = [
    { value: 'true', label: 'Ja' },
    { value: 'false', label: 'Nej, det er bortkommet' },
  ];

  return (
    <StepContainer title={title}>
      {body.length > 0 && (
        <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>
      )}
      <RadioGroup
        name="hasOldPassport"
        options={options}
        value={String((selfServiceData.hasOldPassport as boolean | undefined) ?? '')}
        onChange={handleChange}
        legend={title}
        required={true}
      />
      <NavigationButtons
        onBack={goBack}
        onNext={handleNext}
        nextDisabled={selfServiceData.hasOldPassport === undefined}
      />
    </StepContainer>
  );
};

export default AskHasOldPassportStep;

